import { Link } from './link'

export { Link }
